import React, { FC } from 'react';
import { Row, Typography } from 'components';
import { Badge } from 'antd';
import styles from './styles.module.scss';

const { Text } = Typography;

export type DealStatusType = 'SOURCING' | 'SALES' | 'SUPPLY_ORDER' | 'DELIVERY' | 'CLOSED' | 'REJECTED';

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};

export const DEFAULT_STATUS: StatusMapType = {
  label: 'Unknown',
  color: '#f0f0f0',
  dotColor: 'gray',
};

export const DEAL_STATUS_MAPPING: Record<DealStatusType, StatusMapType> = {
  SOURCING: {
    label: 'Sourcing',
    color: '#fce7fb',
    dotColor: '#e93acd',
  },
  SALES: {
    label: 'Sales',
    color: '#fff6dd',
    dotColor: '#e98f3a',
  },
  SUPPLY_ORDER: {
    label: 'Supply Order',
    color: '#fce7fb',
    dotColor: '#b83a8e',
  },
  DELIVERY: {
    label: 'Delivery',
    color: '#e7ebfc',
    dotColor: '#3a50e9',
  },
  CLOSED: {
    label: 'Closed',
    color: '#e7fcf5',
    dotColor: '#05796B',
  },
  REJECTED: {
    label: 'Rejected',
    color: '#fff2f0',
    dotColor: 'red',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: string;
}

export const DealStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = DEAL_STATUS_MAPPING[type as DealStatusType] ?? DEFAULT_STATUS;

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
